"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const localsync_core_1 = require("localsync-core");
const serversync_1 = require("serversync");
const cookiesync_1 = require("cookiesync");
const storagesync_1 = require("storagesync");
const getSynchronizer = (context) => {
    switch (context.mechanism) {
        case "serversync":
            return serversync_1.serversync(context);
        case "cookiesync":
            return cookiesync_1.cookiesync(context);
        case "storagesync":
            return storagesync_1.storagesync(context);
        default:
            throw new Error(`Unknown mechanism: ${context.mechanism}`);
    }
};
exports.localsync = (config) => {
    const context = localsync_core_1.createContext(config);
    const synchronizer = getSynchronizer(context);
    const createSynchronizer = (publisher, subscriber) => {
        if (!publisher) {
            throw new Error("localsync requires a publisher parameter (Func<TArgs, TMessage>).\n\tThe publisher runs when trigger is invoked and used to select data to be transmitted to other tabs.");
        }
        if (!subscriber) {
            throw new Error("localsync requires a subscriber parameter (Func<[TMessage], void>).\n\tThe subscriber is called when a trigger occurs on another tab and is used to receive published messages from other tabs.");
        }
        return synchronizer(publisher, subscriber);
    };
    return createSynchronizer;
};
//# sourceMappingURL=localsync.js.map